export default {
  methods: {
    /**
     * 受注 or 発注番号を返す
     * @param order
     * @returns {null|string|*}
     */
    dsOrderRequestNumber: function(order) {
      if (['collection', 'general'].includes(order.order_type) || order.self_make_order) {
        return order.order_no;
      } else {
        return order.request_no;
      }
    },
    /**
     * 受注 or 発注番号のラベルを返す.
     * @param order
     * @returns {string}
     */
    dsOrderRequestLabel: function(order) {
      if (['collection', 'general'].includes(order.order_type) || order.self_make_order) {
        return "受注番号";
      } else {
        return "引取搬入番号";
      }
    }
  }
}
